import styled from "styled-components";
import {Ellipsis} from "@FRAMEWORK/ui/desktop/text";
import {Swiper} from "swiper/react";
import {TagSquare} from "@FRAMEWORK/ui/desktop/flag";
import errorImg from "@PUBLIC/P/images/ico/ico_nodata.png";

const Wrap = styled.div`
	width: 1200px;
	margin: 60px auto;
`;

const SlideWrap = styled.div`
	position: relative;
	width: 100%;
	padding-top: 20px;
	margin-top: 20px;
	border-top: 1px solid var(--line-color);
`;

const Slider = styled(Swiper)`
	width: 1200px;
	cursor: pointer;
`;

const SlideImg = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
	width: 285px;
	height: 195px;
	/* background: #f7f7f7 url(${errorImg}) center / 100% no-repeat; */
	> img:not(.fallback_thumb) {
		width: 100%;
		height: 100%;
		object-fit: cover;
	}
`;

const InfoBox = styled.div`
	padding: 15px;
	background: #fff;
	color: var(--default-color);
`;

const SlideTitle = styled.div`
	height: 48px;
	margin-bottom: 8px;
	font-family: "pr-font-medium";
	font-size: 16px;
	line-height: 24px;
	color: var(--emp-color);
	${Ellipsis(2)};
`;

const Date = styled.div`
	font-size: var(--default-size);
	color: var(--default-color);

	> em {
		margin-right: 10px;
		color: var(--emp-color);
	}
`;

const InfoBottomBlock = styled.div`
	display: flex;
	align-items: flex-end;
	justify-content: space-between;
`;

const Price = styled.div`
	margin-top: 10px;
	margin-left: auto;
	font-size: var(--basic-size);
	color: var(--red-color);
	line-height: 1;
	text-align: right;

	strong {
		margin-right: 3px;
		font-size: 20px;
		font-family: "pr-font-medium";
		font-weight: normal;
	}
`;

const Tag = styled(TagSquare)`
	width: 55px;
	height: 55px;
	padding: 0;
`;

const SlideButtonWrap = styled.div`
	button {
		position: absolute;
		top: 50%;
		width: 40px;
		height: 40px;
		border: 1px solid #d0d0d0;
		border-radius: 50%;
		background-color: #fff;
		transform: translateY(-50%);

		&:after {
			position: absolute;
			top: 16px;
			display: block;
			width: 6px;
			height: 6px;
			border-top: 1px solid #848484;
			border-right: 1px solid #848484;
			font-size: 0;
			content: "";
		}
		&:hover:not(:disabled) {
			background-color: #333;
			border-color: #333;
			&:after {
				border-top: 1px solid #fff;
				border-right: 1px solid #fff;
			}
		}
		&:disabled {
			border: 1px solid #e5e5e5;
			cursor: unset;
			&::after {
				border-top: 2px solid #e5e5e5;
				border-right: 2px solid #e5e5e5;
			}
		}
	}
`;
const SlideNextbutton = styled.button`
	right: -60px;

	&:after {
		right: 17px;
		transform: rotate(45deg);
	}
`;
const SlidePrevbutton = styled.button`
	left: -60px;
	&:after {
		left: 17px;
		transform: rotate(-135deg);
	}
`;

export {
	Wrap,
	SlideWrap,
	Slider,
	SlideImg,
	InfoBox,
	SlideTitle,
	Date,
	InfoBottomBlock,
	Price,
	Tag,
	SlideButtonWrap,
	SlideNextbutton,
	SlidePrevbutton,
};
